<template>
    <div v-select-text="value" style="max-width: 600px; margin:0 auto; border: 3px solid blue; padding: 10px 20px;">
        Направления обучения: <br><br>
        <ul style="margin-left: 50px;">
            <li>Профессиональное обучение по рабочим профессиям</li>
            <li>Обучение по промышленной безопасности</li>
            <li>
                Повышение квалификации руководителей и специалистов:
                <ul style="margin-left: 20px;">
                    <li>Иностранные языки (английский, немецкий, русский как иностранный, межкультурный тренинг)</li>
                    <li>Компьютерные курсы</li>
                    <li>Бережливое производство</li>
                    <li>Система менеджмента качества</li>
                    <li>Лидерские и коммуникативные навыки</li>
                </ul>
            </li>
            <li>Охрана труда</li>
            <li>Пожарная безопасность</li>
        </ul>

        <div style="text-align: center;">
            <br>
            <img style="max-width: 337px" src="./i.png"/>

            <br><br>
            <hr color="blue" size="2" width="100%"/>
            <br>
            <i>Тел.: (831) 290 99 24</i><br/>
            <i>Моб. тел.: 8 910 140 76 43</i><br/>
            <i>Электронный адрес: NoskovaDE@gaz.ru</i><br/>
        </div>
    </div>
</template>

<script>
    import SelectText from '@/directives/select-text.js'

    export default {
        props: {
            value: [Array]
        },
        directives: {
            SelectText
        }
    }
</script>